// src/Modal.js
import React from 'react';

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        transition: 'opacity 0.3s ease',
    },
    content: {
        background: '#ffffff',
        padding: '0', // Padding will be handled by header/body
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
        width: '90%',
        maxWidth: '900px', // Increased width for the wide form
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        transform: 'translateY(-20px)',
        transition: 'transform 0.3s ease',
    },
    header: {
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
        flexShrink: 0,
    },
    title: {
        margin: 0,
        fontSize: '22px',
        color: '#333',
        fontWeight: 600,
    },
    closeButton: {
        background: 'transparent',
        border: 'none',
        fontSize: '28px',
        lineHeight: 1,
        color: '#888',
        cursor: 'pointer',
        padding: '0 8px',
    },
    body: {
        padding: '24px',
        overflowY: 'auto', // Enables the scroll view
    },
};

export default function Modal({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.content}>
                <div style={styles.header}>
                    <h2 style={styles.title}>{title}</h2>
                    <button style={styles.closeButton} onClick={onClose}>&times;</button>
                </div>
                <div style={styles.body}>
                    {children}
                </div>
            </div>
        </div>
    );
}